// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-remote-access-controls.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-remote-access-controls',
  title: 'Enforce remote access controls: MDM-enrolled devices only, VPN, MFA and logon monitoring',
  description:
    "Remote access to customer or supplier systems must only be permitted from endpoint devices enrolled in the organisation's MDM or EMM solution. All remote access must be encrypted (e.g. via VPN) and require multi-factor authentication. Employees working from home must be instructed in router security, MFA, device sharing restrictions and physical security. All remote logon events must be logged and monitored.",
  category: 'access',
  scfIds: ['SCF-NET-004', 'SCF-IAM-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Remote access control policy and procedure is published',
    },
    { type: 'document-approved', description: 'Policy has been approved' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
